export const TrackConfig = new Map<string, any>([
  [
    "thumb",
    { name: "封面", icon: "icon-tupian", menus: ["visible", "delete"] },
  ],
  ["video", { name: "镜头", icon: "icon-shipin", menus: ["mute", "delete"] }],
  [
    "audio",
    {
      name: "音频",
      icon: "icon-bendiyinle",
      background: "#073EBC",
      menus: ["mute", "visible", "delete"],
    },
  ],
  [
    "audioEffect",
    {
      name: "音效",
      icon: "icon-yinxiao1",
      background: "#0953FD",
      menus: ["visible", "delete"],
    },
  ],
  [
    "text",
    {
      name: "文本",
      icon: "icon-wenben",
      background: "#C70A0A",
      menus: ["visible", "delete"],
    },
  ],
  ["image", { name: "图片" }],
  [
    "sticker",
    {
      name: "贴纸",
      icon: "icon-tiezhi",
      background: "#7215C4",
      menus: ["visible", "delete"],
    },
  ],
  [
    "effect",
    {
      name: "特效",
      icon: "icon-texiao",
      background: "#EB7402",
      menus: ["visible", "delete"],
    },
  ],
  [
    "background",
    {
      name: "背景",
      icon: "icon-beijing",
      background: "#7215C4",
      menus: ["visible", "delete"],
    },
  ],
  [
    "picInPic",
    {
      name: "画中画",
      icon: "icon-huazhonghua",
      background: "#864343",
      menus: ["mute", "delete"],
    },
  ],
  [
    "narrator",
    {
      name: "旁白",
      icon: "icon-yuyinbowen",
      background: "#B00E62",
      menus: ["mute", "visible", "delete"],
    },
  ],
  [
    "template",
    {
      name: "模板",
      icon: "icon-template",
      background: "#B00E62",
      menus: [],
    },
  ],
  [
    "filter",
    {
      name: "滤镜",
      icon: "icon-lvjing",
      background: "#2A7B3C",
      menus: ["visible", "delete"],
    },
  ],
  ["transition", {}],
]);

// 位于主轨道上方的轨道，在分镜上方
export const trackDirectionUp = [
  "text",
  "image",
  "sticker",
  "picInPic",
  "effect",
  "thumb",
  "filter",
];

export const baseFps = 30;

/**
 * 单位帧时间，毫秒
 */
export const UnitFrame2ms = 1e3 / baseFps;
/**
 * 单位帧时间，微秒
 */
export const UnitFrame2μs = 1e6 / baseFps;

export const WaveOptions = {
  height: 28,
  width: "100%",
  splitChannels: false,
  normalize: true,
  waveColor: "#007bff",
  progressColor: "#dd5e98",
  cursorColor: "#ddd5e9",
  cursorWidth: 0,
  barWidth: 1,
  barGap: 1,
  barRadius: 1,
  barHeight: 0.6,
  barAlign: "bottom",
  minPxPerSec: 1,
  fillParent: true,
  mediaControls: true,
  autoplay: false,
  interact: false,
  dragToSeek: false,
  hideScrollbar: false,
  audioRate: 0.1,
  autoScroll: true,
  autoCenter: true,
  sampleRate: 8000,
} as const;
